var FONT_CONFIG = {
    'Plus Jakarta Sans': {
        'font-family': 'Plus Jakarta Sans',
        'heading-one-font-size': '20px',
        'heading-one-font-weight': '600',
        'heading-two-font-size': '18px',
        'heading-two-font-weight': '600',
        'heading-three-font-size': '16px',
        'heading-three-font-weight': '600',
        'body-one-level-one-font-size': '16px',
        'body-one-level-one-font-weight': '400',
        'body-two-level-one-font-size': '14px',
        'body-two-level-one-font-weight': '600',
        'body-two-level-two-font-size': '14px',
        'body-two-level-two-font-weight': '500',
        'body-two-level-three-font-size': '14px',
        'body-two-level-three-font-weight': '400',
        'body-three-level-one-font-size': '12px',
        'body-three-level-one-font-weight': '500',
        'body-three-level-two-font-size': '12px',
        'body-three-level-two-font-weight': '400',
        'tags-font-size': '10px',
        'tags-font-weight': '600',
        'button-large-font-size': '16px',
        'button-large-font-weight': '600',
        'button-medium-font-size': '14px',
        'button-medium-font-weight': '600',
        'button-small-font-size': '12px',
        'button-small-font-weight': '600'
    },
    Roboto: {
        'font-family': 'Roboto',
        'heading-one-font-size': '20px',
        'heading-one-font-weight': '600',
        'heading-two-font-size': '18px',
        'heading-two-font-weight': '600',
        'heading-three-font-size': '16px',
        'heading-three-font-weight': '600',
        'body-one-level-one-font-size': '16px',
        'body-one-level-one-font-weight': '400',
        'body-two-level-one-font-size': '14px',
        'body-two-level-one-font-weight': '500',
        'body-two-level-two-font-size': '14px',
        'body-two-level-two-font-weight': '400',
        'body-two-level-three-font-size': '14px',
        'body-two-level-three-font-weight': '400',
        'body-three-level-one-font-size': '12px',
        'body-three-level-one-font-weight': '500',
        'body-three-level-two-font-size': '12px',
        'body-three-level-two-font-weight': '400',
        'tags-font-size': '10px',
        'tags-font-weight': '600',
        'button-large-font-size': '16px',
        'button-large-font-weight': '600',
        'button-medium-font-size': '14px',
        'button-medium-font-weight': '600',
        'button-small-font-size': '12px',
        'button-small-font-weight': '600'
    },
    Sora: {
        'font-family': 'Sora',
        'heading-one-font-size': '20px',
        'heading-one-font-weight': '600',
        'heading-two-font-size': '18px',
        'heading-two-font-weight': '600',
        'heading-three-font-size': '16px',
        'heading-three-font-weight': '600',
        'body-one-level-one-font-size': '16px',
        'body-one-level-one-font-weight': '400',
        'body-two-level-one-font-size': '14px',
        'body-two-level-one-font-weight': '600',
        'body-two-level-two-font-size': '14px',
        'body-two-level-two-font-weight': '400',
        'body-two-level-three-font-size': '14px',
        'body-two-level-three-font-weight': '400',
        'body-three-level-one-font-size': '12px',
        'body-three-level-one-font-weight': '400',
        'body-three-level-two-font-size': '12px',
        'body-three-level-two-font-weight': '400',
        'tags-font-size': '10px',
        'tags-font-weight': '600',
        'button-large-font-size': '16px',
        'button-large-font-weight': '600',
        'button-medium-font-size': '14px',
        'button-medium-font-weight': '600',
        'button-small-font-size': '12px',
        'button-small-font-weight': '600'
    },
    'Zilla Slab': {
        'font-family': 'Zilla Slab',
        'heading-one-font-size': '24px',
        'heading-one-font-weight': '600',
        'heading-two-font-size': '21px',
        'heading-two-font-weight': '600',
        'heading-three-font-size': '19px',
        'heading-three-font-weight': '600',
        'body-one-level-one-font-size': '16px',
        'body-one-level-one-font-weight': '600',
        'body-two-level-one-font-size': '16px',
        'body-two-level-one-font-weight': '500',
        'body-two-level-two-font-size': '16px',
        'body-two-level-two-font-weight': '400',
        'body-two-level-three-font-size': '16px',
        'body-two-level-three-font-weight': '400',
        'body-three-level-one-font-size': '14px',
        'body-three-level-one-font-weight': '500',
        'body-three-level-two-font-size': '14px',
        'body-three-level-two-font-weight': '400',
        'tags-font-size': '11px',
        'tags-font-weight': '500',
        'button-large-font-size': '19px',
        'button-large-font-weight': '600',
        'button-medium-font-size': '16px',
        'button-medium-font-weight': '600',
        'button-small-font-size': '14px',
        'button-small-font-weight': '600'
    },
    Quicksand: {
        'font-family': 'Quicksand',
        'heading-one-font-size': '20px',
        'heading-one-font-weight': '700',
        'heading-two-font-size': '18px',
        'heading-two-font-weight': '700',
        'heading-three-font-size': '16px',
        'heading-three-font-weight': '700',
        'body-one-level-one-font-size': '16px',
        'body-one-level-one-font-weight': '500',
        'body-two-level-one-font-size': '14px',
        'body-two-level-one-font-weight': '700',
        'body-two-level-two-font-size': '14px',
        'body-two-level-two-font-weight': '600',
        'body-two-level-three-font-size': '14px',
        'body-two-level-three-font-weight': '500',
        'body-three-level-one-font-size': '12px',
        'body-three-level-one-font-weight': '600',
        'body-three-level-two-font-size': '12px',
        'body-three-level-two-font-weight': '500',
        'tags-font-size': '10px',
        'tags-font-weight': '600',
        'button-large-font-size': '16px',
        'button-large-font-weight': '700',
        'button-medium-font-size': '14px',
        'button-medium-font-weight': '700',
        'button-small-font-size': '12px',
        'button-small-font-weight': '600'
    },
    'Crimson Pro + DM Sans': {
        'font-family': 'Crimson Pro',
        'heading-one-font-size': '24px',
        'heading-one-font-weight': '600',
        'heading-two-font-size': '21px',
        'heading-two-font-weight': '600',
        'heading-three-font-size': '20px',
        'heading-three-font-weight': '500',
        'body-one-level-one-font-size': '20px',
        'body-one-level-one-font-weight': '400',
        'body-two-level-one-font-size': '17px',
        'body-two-level-one-font-weight': '500',
        'body-two-level-two-font-size': '17px',
        'body-two-level-two-font-weight': '400',
        'body-two-level-three-font-size': '17px',
        'body-two-level-three-font-weight': '300',
        'body-three-level-one-font-size': '12px',
        'body-three-level-one-font-weight': '500',
        'body-three-level-two-font-size': '12px',
        'body-three-level-two-font-weight': '400',
        'tags-font-size': '11px',
        'tags-font-weight': '500',
        'button-large-font-size': '16px',
        'button-large-font-weight': '700',
        'button-large-font-family': 'DM Sans',
        'button-medium-font-size': '14px',
        'button-medium-font-weight': '700',
        'button-medium-font-family': 'DM Sans',
        'button-small-font-size': '12px',
        'button-small-font-weight': '500',
        'button-small-font-family': 'DM Sans'
    },
    Merriweather: {
        'font-family': 'Merriweather',
        'heading-one-font-size': '20px',
        'heading-one-font-weight': '700',
        'heading-one-line-height': '28px',
        'heading-two-font-size': '18px',
        'heading-two-font-weight': '700',
        'heading-two-line-height': '24px',
        'heading-three-font-size': '16px',
        'heading-three-font-weight': '700',
        'heading-three-line-height': '22px',
        'body-one-level-one-font-size': '16px',
        'body-one-level-one-font-weight': '400',
        'body-one-level-one-line-height': '22px',
        'body-two-level-one-font-size': '14px',
        'body-two-level-one-font-weight': '700',
        'body-two-level-one-line-height': '20px',
        'body-two-level-two-font-size': '14px',
        'body-two-level-two-font-weight': '400',
        'body-two-level-two-line-height': '20px',
        'body-two-level-three-font-size': '14px',
        'body-two-level-three-font-weight': '400',
        'body-two-level-three-line-height': '20px',
        'body-three-level-one-font-size': '12px',
        'body-three-level-one-font-weight': '700',
        'body-three-level-one-line-height': '16px',
        'body-three-level-one-font-family': 'Merriweather Sans',
        'body-three-level-two-font-size': '12px',
        'body-three-level-two-font-weight': '400',
        'body-three-level-two-line-height': '16px',
        'body-three-level-two-font-family': 'Merriweather Sans',
        'tags-font-size': '11px',
        'tags-font-weight': '400',
        'tags-line-height': '14px',
        'tags-font-family': 'Merriweather Sans',
        'button-large-font-size': '16px',
        'button-large-font-weight': '700',
        'button-large-line-height': '22px',
        'button-medium-font-size': '14px',
        'button-medium-font-weight': '700',
        'button-medium-line-height': '20px',
        'button-small-font-size': '12px',
        'button-small-font-weight': '400',
        'button-small-line-height': '16px',
        'button-small-font-family': 'Merriweather Sans'
    }
};
var createFontCSSVariables = function (fontName) {
    var root = document.documentElement;
    var config = FONT_CONFIG[fontName];
    for (var key in config) {
        root === null || root === void 0 ? void 0 : root.style.setProperty("--".concat(key), config[key]);
    }
};

export { FONT_CONFIG, createFontCSSVariables };
//# sourceMappingURL=FontConfig.js.map
